<template>
  <v-card :loading="loading" class="rounded-xl" elevation="0">
    <div class="pa-3">
      <div class="d-flex gap-4 align-center">
        <v-icon v-if="!data?.user?.name && !loading" size="40">
          mdi-account-off
        </v-icon>
        <base-avatar
          v-else
          :seed="data?.user?.id || ''"
          :src="data?.user?.photo"
          :size="40"
        ></base-avatar>
        <div class="flex-1">
          <h6 class="mb-0">{{ data?.user?.name || "Conta não criada" }}</h6>
          <p class="mb-0 lh-2 text-12">{{ data?.user?.phone }}</p>
          <p class="mb-0 lh-2 text-12">{{ data?.user?.email }}</p>
        </div>
        <div class="align-self-start d-flex gap-1 align-center">
          <v-chip
            v-if="data?.user?.active === false"
            color="red"
            text-color="white"
            x-small
            class="text-12"
            label
          >
            Inativo
          </v-chip>
          <v-btn
            small
            @click="$emit('refresh')"
            icon
            :loading="loading"
            :disabled="loading"
          >
            <v-icon small>mdi-refresh</v-icon>
          </v-btn>
        </div>
      </div>

      <!-- <div class="mt-2" v-if="!loading">
        <v-btn v-if="data?.user?.name" text x-small> Redefinir senha </v-btn>
        <v-btn v-else text x-small>Criar conta</v-btn>
      </div> -->
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    data: Object,
    loading: Boolean,
  },
};
</script>

<style>
</style>